import React from 'react';

const EmptyState = ({ message, subMessage }) => {
  return (
    <div className="text-center py-16">
      <h3 className="text-xl font-semibold text-slate-700 mb-2">
        {message || 'No events found'}
      </h3>
      <p className="text-slate-500 text-sm">
        {subMessage || 'Try adjusting your search or filters'}
      </p>
    </div>
  );
};

export default EmptyState;
